import { Grid } from "@mui/material";
import { useAuthContext } from "../../hooks/Auth";
import CategoriaCard from "../UmmIACategories/CategoriaCard";

const CardsContainer = () => {
  const { user } = useAuthContext();
  return (
    <Grid container spacing={{xs:2, md:4, lg:8, xl:10}} px={{xs:1, md:0}}>
      {user?.categories.map((cat) => {
        return (
          <Grid item xs={12} sm={6} md={4} key={cat.label}>
            <CategoriaCard {...cat} />{" "}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CardsContainer;
